import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material';
import { useThemeContext } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { darkMode, toggleTheme } = useThemeContext();
  const theme = useTheme();

  return (
    <Tooltip title={darkMode ? "Switch to light mode" : "Switch to dark mode"}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        size="small"
        aria-label="toggle theme"
        sx={{
          transition: 'all 0.3s',
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        {darkMode ? (
          <LightModeIcon 
            sx={{ 
              fontSize: 22,
              color: theme.palette.primary.main,
            }} 
          />
        ) : (
          <DarkModeIcon 
            sx={{ 
              fontSize: 22,
              color: theme.palette.primary.main,
            }} 
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle; 